import {
  backButton,
  emitEvent,
  init,
  mockTelegramEnv,
  retrieveLaunchParams,
  swipeBehavior,
  viewport,
} from "@telegram-apps/sdk-react";

const noInsets = { left: 0, top: 0, bottom: 0, right: 0 } as const;

const themeParams = {
  accent_text_color: "#ffc24d",
  bg_color: "#08080a",
  button_color: "#f0a122",
  button_text_color: "#22190a",
  destructive_text_color: "#ff5a6e",
  header_bg_color: "#08080a",
  hint_color: "#6a6a74",
  link_color: "#ffc24d",
  secondary_bg_color: "#141418",
  section_bg_color: "#141418",
  section_header_text_color: "#9a9aa4",
  subtitle_text_color: "#9a9aa4",
  text_color: "#f4f4f6",
} as const;

/** Настоящий Mini App (есть initData), а не mock-окружение для браузера. */
export function isTelegramWebApp(): boolean {
  return Boolean(
    (window as any).Telegram?.WebApp &&
      (window as any).Telegram.WebApp.initData?.length
  );
}

/**
 * Инициализация SDK. Вне Telegram (ссылка в браузере) поднимаем mock-окружение,
 * как в kef-tma: приложение работает одинаково и в Mini App, и по прямой ссылке.
 */
export function initTelegram() {
  if (!isTelegramWebApp()) {
    mockTelegramEnv({
      launchParams: {
        tgWebAppThemeParams: themeParams,
        tgWebAppData: new URLSearchParams([
          ["user", JSON.stringify({ id: 0, first_name: "Гость" })],
          ["hash", ""],
          ["signature", ""],
          ["auth_date", Date.now().toString()],
        ]),
        tgWebAppStartParam: "debug",
        tgWebAppVersion: "8",
        tgWebAppPlatform: "tdesktop",
      },
      onEvent(e) {
        if (e[0] === "web_app_request_theme") {
          return emitEvent("theme_changed", { theme_params: themeParams });
        }
        if (e[0] === "web_app_request_viewport") {
          return emitEvent("viewport_changed", {
            height: window.innerHeight,
            width: window.innerWidth,
            is_expanded: true,
            is_state_stable: true,
          });
        }
        if (e[0] === "web_app_request_content_safe_area") {
          return emitEvent("content_safe_area_changed", noInsets);
        }
        if (e[0] === "web_app_request_safe_area") {
          return emitEvent("safe_area_changed", noInsets);
        }
        return undefined;
      },
    });
  }

  init({ acceptCustomStyles: true });

  Promise.resolve(viewport.mount()).then(() => {
    if (viewport.expand.isAvailable()) viewport.expand();
  });
  swipeBehavior.mount();
  if (swipeBehavior.disableVertical.isAvailable()) {
    swipeBehavior.disableVertical();
  }
  backButton.mount();
}

/** Telegram id пользователя, если открыто как Mini App; иначе null. */
export function getTelegramUserId(): number | null {
  if (!isTelegramWebApp()) return null;
  try {
    const id = retrieveLaunchParams().tgWebAppData?.user?.id;
    return typeof id === "number" && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function getTelegramFirstName(): string | null {
  if (!isTelegramWebApp()) return null;
  try {
    return retrieveLaunchParams().tgWebAppData?.user?.first_name ?? null;
  } catch {
    return null;
  }
}
